module.exports = __webpack_public_path__ + "img/15.d8d45fef.jpg";